import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Icon from "./Icon";
import { useAuth } from "../context/AuthContext";

function LanguageSwitcher({ className, buttonClassName, mustUpdatUser = true }) {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const { updateUser } = useAuth();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem("i18nextLng", lng);
        if (mustUpdatUser) {
            updateUser({
                language: lng,
            });
        }
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const languages = [
        { code: "en", name: t("languageSwitcher.english") },
        { code: "es", name: t("languageSwitcher.spanish") },
        { code: "fr", name: t("languageSwitcher.french") },
        { code: "pt", name: t("languageSwitcher.portuguese") },
        { code: "it", name: t("languageSwitcher.italian") },
        { code: "tr", name: t("languageSwitcher.turkish") },
        { code: "hi", name: t("languageSwitcher.hindi") },
        { code: "ar", name: t("languageSwitcher.arabic") },

        { code: "de", name: t("languageSwitcher.german") },


    ];

    // Get the current language name
    const currentLanguage =
        languages.find((lang) => lang.code === i18n.language)?.name ||
        languages[0].name;

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                className={
                    buttonClassName
                        ? `${buttonClassName} ${className || ""}`
                        : `flex items-center space-x-1 px-3 py-1.5 text-sm rounded bg-gray-100  hover:bg-gray-200  transition-colors ${className || ""}`
                }
                onClick={() => setIsOpen(!isOpen)}
                aria-label={t("languageSwitcher.label")}
                title={t("languageSwitcher.label")}
            >
                <span>{currentLanguage}</span>
                <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} size={16} />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-1 py-1 w-36 bg-white  rounded-md shadow-lg border border-gray-200 dark:border-gray-700 z-50">
                    {languages.map((language) => (
                        <button
                            key={language.code}
                            type="button"
                            onClick={() => changeLanguage(language.code)}
                            className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 ${
                                i18n.language === language.code
                                    ? "text-blue-600 dark:text-blue-400 font-medium"
                                    : "text-gray-700 dark:text-gray-300"
                            }`}
                        >
                            {language.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default LanguageSwitcher;
